export default {"src":"/_next/static/media/play.c2adc39f.svg","height":62,"width":62,"blurWidth":0,"blurHeight":0};